import { createContext, useContext, useEffect, useState, useMemo } from "react";
import { api } from "@/lib/api";
import { logWarn } from "@/lib/log";

/**
 * Every-page context that tracks which tracks are free TODAY as part of
 * Melo Mondays. Fetched once on app boot so <TrackRow /> can flip its
 * price CTA to "FREE TODAY" without every card hitting the API.
 */
const MeloMondayContext = createContext({ active: false, isFree: () => false });

export function MeloMondayProvider({ children }) {
  const [active, setActive] = useState(false);
  const [ids, setIds] = useState(new Set());

  useEffect(() => {
    api.get("/melo-mondays/picks")
      .then((r) => {
        setActive(!!r.data.active);
        setIds(new Set(r.data.track_ids || []));
      })
      .catch((e) => logWarn("[melo-monday] picks load failed", e?.response?.status));
  }, []);

  const value = useMemo(
    () => ({ active, isFree: (trackId) => active && ids.has(trackId) }),
    [active, ids]
  );

  return <MeloMondayContext.Provider value={value}>{children}</MeloMondayContext.Provider>;
}

export const useMeloMonday = () => useContext(MeloMondayContext);
